module.exports = __webpack_public_path__ + "static/img/NASH-KING.be39e1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NASH-KING.jpg
// module id = ZpJu
// module chunks = 0